<div class="container single-view">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="system-settings-title" class="section-title">{{ 'SYSTEM_SETTINGS.TITLE' | translate }}</h1>
          <p data-testid="system-settings-subtitle" class="section-subtitle mt-1 text-base">{{ 'SYSTEM_SETTINGS.SUBTITLE' | translate }}</p>
        </div>
        <div class="flex items-end justify-between gap-3">
          @if (isSuperAdmin) {
            <button data-testid="new-company-btn" class="btn primary-btn" type="button" (click)="openCreateCompanyModal()">Add company</button>
          }
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            @if (tabs.length) {
              <div class="system-settings-layout">
                <aside class="system-settings-nav flex-col self-start gap-1 px-2 py-2" [attr.aria-label]="'SYSTEM_SETTINGS.TITLE' | translate">
                  @for (tab of tabs; track trackByTabRoute($index, tab)) {
                    <button type="button" class="system-settings-nav-item w-full px-3 py-2.5 border-none"
                      [class.active]="tab.route === activeTabRoute" [attr.aria-current]="tab.route === activeTabRoute ? 'page' : null"
                      (click)="selectTab(tab.route)">
                      {{ tab.label | translate }}
                    </button>
                  }
                </aside>
                <section class="system-settings-content">
                  @switch (activeTabRoute) {
                    @case ('company') {
                      <app-company-settings
                      (createBrandRequested)="selectTab('brands')"></app-company-settings>
                    }
                    @case ('brands') {
                      <app-brands-settings></app-brands-settings>
                    }
                    @case ('features') {
                      <app-features-management></app-features-management>
                    }
                    @case ('notices') {
                    <app-notices-settings></app-notices-settings>
                    }
                    @case ('tables') {
                      <app-tables-columns-settings></app-tables-columns-settings>
                    }
                    @case ('export') {
                      <app-export-columns-settings></app-export-columns-settings>
                    }
                    @case ('specification') {
                      <app-specifications-feature-settings></app-specifications-feature-settings>
                    }
                    @case ('pattern') {
                      <app-patterns-settings></app-patterns-settings>
                    }
                    @case ('roles') {
                      <app-roles-settings></app-roles-settings>
                    }
                    @case ('serialisation') {
                      <app-serialization-settings></app-serialization-settings>
                    }
                    @case ('machine-clients') {
                      <app-machine-client-settings></app-machine-client-settings>
                    }
                    <!--
                    @case ('translations') {
                      <app-translations-settings></app-translations-settings>
                    }
                    -->
                    @case ('integrations') {
                      <app-integrations-settings></app-integrations-settings>
                    }
                    @case ('branding') {
                      <app-branding-settings [activeTabIndex]="activeBrandingTabIndex" (activeTabIndexChange)="onBrandingTabChange($event)"></app-branding-settings>
                    }
                  }
                </section>
              </div>
            }
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
